<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Originally from the north of England, David Peart now lives in a village in Essex with his three daughters. He is a widowed husband to Joanne, who died in July 2019.</p>
<br/><p style="text-indent:0em;">He has previously written two children’s books to help his daughters during their grieving process. <em>I Want to Hug Mummy</em>, and <em>It’s Okay to Feel Happy</em> are now being used to help other children and families who have experienced loss. That inspired him to write a book from his point of view that can help other people who have related experiences—not just bereavement but other disruptive events.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3cb348e8